    <app-grid-edit-week [setDataSourceWeekApproval]="dataSourceWeekApproval"
                    [employeeDataSource]="employees"
                    [timetypeDataSource]="timetypes"
                    setEditMode="batch"
                    [selectedEmployeeInput]="selectedEmployeeId" 
                    [showEmployeeSelect]="isEmployeeSelectShown"
                    [setShowUnconfirmed]="true"
                    [projectIds]="projectIdsDataSource"
                    (loading)="onLoadingDetail($event)"
                    (loadRecords)="onLoadRecords($event)"
                    (cellPrepared)="onCellPrepared($event)"
                    (rowInserting)="onRowInserting($event)"
                    (rowUpdating)="onRowUpdating($event)"
                    [allowEditUnconfirmed]="false"></app-grid-edit-week>
